<template>
  <div class="footer">
    <mt-tabbar v-model="selected">
      <mt-tab-item id="/home" @click.native="nav_jump('/home')">
        <img slot="icon" :src="selected=='/home'?'https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/footer_home/icon_01_1.png':'https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/footer_home/icon_01.png'"/>
        Home
      </mt-tab-item>
      <mt-tab-item id="/exhibitor" @click.native="nav_jump('/exhibitor')">
        <img slot="icon" :src="selected=='/exhibitor'?'https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/footer_home/icon_02_1.png':'https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/footer_home/icon_02.png'"/>
        Exhibits
      </mt-tab-item>
      <mt-tab-item id="/live" @click.native="nav_jump('/live')">
        <img slot="icon" :src="selected=='/live'?'https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/footer_home/icon_04_1.png':'https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/footer_home/icon_04.png'"/>
        Video
      </mt-tab-item>
      <mt-tab-item id="/user" @click.native="nav_jump('/user')">
        <img slot="icon" :src="selected=='/user'?'https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/footer_home/icon_05_1.png':'https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/footer_home/icon_05.png'"/>
        user
      </mt-tab-item>
    </mt-tabbar>
  </div>
</template>

<script>
import { Tabbar, TabItem } from 'mint-ui'
import 'mint-ui/lib/style.css'
export default {
  components:{
    'mt-tabbar':Tabbar,
    'mt-tab-item':TabItem
  },
  props:['cc'],
  data(){
    return{
      selected:sessionStorage.getItem('selected')?sessionStorage.getItem('selected'):'/home'
    }
  },
  methods:{
    nav_jump(url){
      if(url!==this.$route.path){
        this.$router.push(url)
      }
    }
  },
  watch:{
    $route () {
        // console.log('改变路由')
      this.selected = sessionStorage.getItem('selected')
    },
    // selected:(val,oldVal)=>{
    //   // console.log(val,oldVal);
    // },
    
  }
}
</script>

<style scoped>
  /* .footer{
    position: fixed;
    bottom: 0;
    left: 0;
    height: 50px;
    width: 100%;
    background-color: white;
    display: flex;
    box-shadow: 0 0 10px rgba(0, 0, 0, .2);
  }
  .footer li{
    padding: 5px 10px;
    width: 20%;
    text-align: center;
    font-size: 12px;
    color: #333;
  }
  .footer li i{
    display: block;
    width: 100%;
    font-size: 25px;
  }
  .footer .active{
    color: #008baf;
  } */
  /* img{
    width: 50%;
    display: block;
    margin: 0 auto;
    height: auto;
  } */
  .footer>>>.mint-tabbar > .mint-tab-item.is-selected{
    color: #008baf;
  }
</style>